/**
 * The coordinates with consecutive repeats removed: a point with the same
 * longitude and latitude as the one before it (elevation is ignored). Pure;
 * always returns a new array.
 *
 * turf 7.2's nearestPointOnLine throws "coordinates must contain numbers" on a
 * zero-length segment, and a snapped segment between two clicks that snap to
 * the same spot on a path is exactly that: the same coordinate twice. Removing
 * the repeats changes neither the shape nor the length of the line.
 */
export function withoutRepeatedPoints(coords: number[][]): number[][] {
  const result: number[][] = [];
  for (const coord of coords) {
    const previous = result[result.length - 1];
    if (!previous || previous[0] !== coord[0] || previous[1] !== coord[1]) {
      result.push(coord);
    }
  }
  return result;
}

/**
 * Whether any point repeats the one before it, i.e. whether the line contains a
 * zero-length segment. Equivalent to `withoutRepeatedPoints(coords).length !==
 * coords.length`, written out so it never dereferences a malformed entry: callers
 * use it to decide whether turf can be trusted with the line at all.
 */
export function hasRepeatedPoints(coords: number[][]): boolean {
  for (let i = 1; i < coords.length; i++) {
    const previous = coords[i - 1];
    const current = coords[i];
    if (!previous || !current) continue;
    if (previous[0] === current[0] && previous[1] === current[1]) return true;
  }
  return false;
}
